<template>
  <section
    v-if="packageCategories?.length > 0"
    class="gf-search-filter-package-categories"
  >
    <div
      class="gf-search-filter-package-categories__header"
      v-if="showHeader"
    >
      <b class="title">{{ $t('message.categories') }}</b>
      <router-link
        v-if="$route.query?.categories?.length > 0"
        class="reset-button btn btn-sm"
        active-class=""
        exact-active-class=""
        tag="button"
        :to="{ query: { ...$route.query, categories: undefined, page: 0 } }"
      >
        Сбросить
      </router-link>
    </div>

    <div class="gf-search-filter-package-categories__list">
      <router-link
        v-for="(packageCategory, index) in categories"
        :key="index"
        class="gf-search-filter-package-categories__item"
        :class="{ '--active': $route.query?.categories === packageCategory }"
        active-class=""
        exact-active-class=""
        tag="a"
        :to="{ query: { ...$route.query, categories: packageCategory, page: 0 } }"
      >
        <span class="type-title">{{ packageCategory }}</span>
        <router-link
          class="reset-type btn"
          type="button"
          active-class=""
          exact-active-class=""
          tag="button"
          :to="{ query: { ...$route.query, categories: undefined, page: 0 } }"
        >
          <i class="gf-icon gf-icon-x"></i>
        </router-link>
      </router-link>
      <button
        class="show-more btn btn-sm"
        v-if="isTooBigList && showShortList"
        @click="$emit('showMore')"
      >
        Еще
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GfSearchFilterPackageCategories',
  props: {
    showShortList: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    packageCategories() {
      return this.$store.getters.getSearchPackageCategories || [];
    },
    isTooBigList() {
      return this.packageCategories?.length > 5;
    },
    categories() {
      return this.showShortList && this.isTooBigList
        ? this.packageCategories.slice(0, 5)
        : this.packageCategories;
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-search-filter-package-categories';

#{$this} {
  width: 100%;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--light);
  border: 1px solid var(--border-color);
  border-radius: 6px;

  @include theme.md {
    width: 300px;
  }

  #{$this}__header {
    min-height: 30px;
    display: flex;
    align-items: center;
    gap: 8px;

    & .title {
      font-size: 16px;

      @include theme.md {
        font-size: 14px;
      }
    }

    & .reset-button {
      margin-left: auto;
      color: var(--text-muted);
    }
  }

  #{$this}__list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @include theme.md {
      max-height: 300px;
      overflow: auto;
    }

    #{$this}__item {
      min-height: 38px;
      padding: 6px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 8px;

      @include theme.md {
        min-height: 32px;
      }

      & > .type-title {
        color: var(--text);
      }

      & > .reset-type {
        margin-left: auto;
        padding: 0;
        display: none !important;
        color: var(--text-muted);

        &:hover {
          color: var(--text);
        }

        & > i {
          font-size: 20px !important;

          @include theme.md {
            font-size: 16px !important;
          }
        }
      }

      &.--active {
        background-color: var(--bg-light);

        & > .reset-type {
          display: flex !important;
        }
      }

      &:hover {
        background-color: var(--bg-light);
      }
    }

    & .show-more {
      padding: 10px;
      background-color: var(--bg-light);
    }
  }
}
</style>
